export enum TypographyVariants {
  h1 = "h1",
  h2 = "h2",
  h3 = "h3",
  h4 = "h4",
  paragraphS = "paragraphS",
  paragraphSBold = "paragraphSBold",
  paragraphM = "paragraphM",
  paragraphMBold = "paragraphMBold",
  paragraphL = "paragraphL",
  paragraphLBold = "paragraphLBold",
  subtitle = "subtitle",
  subtitleBold = "subtitleBold",
}
